"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBot = void 0;
var BOT_REGEX = /bot|crawl|spider|AutoIt|requests|microsoft office|CFNetwork|Scrapy|k6\.io|vp-digital-image-processor|feed|facebookexternal|github\.com/i;
/**
 * Check if the user agent is from a bot
 * @param userAgent: The user agent of the request or browser
 * @returns if this UA is a bot
 */
var isBot = function (userAgent) {
    if (!userAgent) {
        return false;
    }
    return BOT_REGEX.test(userAgent);
};
exports.isBot = isBot;
